import React, { Component } from "react";
import Chart from "./components/Chart";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import { queryGetWordCloud } from "Apollo";
import { graphql } from "react-apollo";
import EmptyPanel from "./components/EmptyPanel";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = graphql(queryGetWordCloud, gqlOptions)(
  class WordCloud extends Component {
    render() {
      const { data: { loading, getWordCloud } } = this.props;
      let series = [];
      if (!loading && getWordCloud) {
        series = getWordCloud.data.filter(item => {
          return item.name.indexOf("@") < 0;
        });
      }
      const opt = {
        chartType: "wordcloud",
        title: "Word Cloud",
        series
      };
      if (series[0]) {
        return <Chart {...opt} />;
      } else {
        return <EmptyPanel />;
      }
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/WordCloud.js